export const CatPatternSolid = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			fill={props.mainColor || "#cbd7e2"}
			stroke={props.strokeColor || "#384f64"}
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="0.5px">
			<title>Solid color cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2-2" data-name="Layer 2">
					<path
						className="cls-1"
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M22.3,87.76S23.07,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.55,63.15,3.35,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.91,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.9,42a6,6,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.53,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.41,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternTuxedo = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.94"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="0.5px">
			<title>Tuxedo cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_2" data-name="Layer 2">
					<g id="Layer_3" data-name="Layer 3">
						<path
							fill={props.secondaryColor || "#cbd7e2"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-1"
							d="M22.3,87.76S23.07,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.55,63.15,3.35,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.91,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.9,42a6,6,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.53,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.41,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M9.09,62.68c.39,0,.26-.1.26-.1.82-3.26-2.51-4.69-2.51-4.69a7.65,7.65,0,0,0-2.81-1C2.44,55.59,3.2,55,3.2,55a22.46,22.46,0,0,0,1.66-5s-2,3.21-2.87,4.25c0,0-3.14,3.28-.85,4.56a9.64,9.64,0,0,1,2.51,2.4A7.89,7.89,0,0,0,9.09,62.68Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M22.08,80.21l.22-.3A69.73,69.73,0,0,0,24,71.84c.95-6.79-6.62-7.86-7.87-6.7C16.08,65.14,21.59,69.06,22.08,80.21Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M18.29,103.7a.27.27,0,0,0,.13-.38c-1.59-3-6.6-3.68-6.6-3.68a93.48,93.48,0,0,1-6.95,7s-3,2.68-2.57,5.39a2.26,2.26,0,0,0,3,1.15A21.39,21.39,0,0,0,10,110.52S14,107,14.63,106.44,17.88,103.93,18.29,103.7Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M51.79,106c0-.2.07-.48-.08-.51-4.18-.86-7.75,2-7.75,2s-.29,4.15-2.13,6.42c0,0-2.82,3.13-1.27,4,0,0,2.09,1.64,6.64,0a4.77,4.77,0,0,0,3.18-3.34A47.53,47.53,0,0,0,51.79,106Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M103.36,105.29s-3.89,1.86-6,.95a8.75,8.75,0,0,0-4.83-.23,24.35,24.35,0,0,1-4.74,3.44s-3.78,2-4.1,2.29c0,0-1.59,1.27,0,3.2,0,0,2.42,1.27,6.76,0,0,0,2,.07,6.52-3.64,0,0,5.22-4.38,5.94-5.59Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M138,99.34s.13.53-2.07,1.87A9,9,0,0,1,131,102.3a17.66,17.66,0,0,1,1.07,7.44,15.34,15.34,0,0,1-.46,3.17,2,2,0,0,0,1.79,2.47,4.75,4.75,0,0,0,3.79-.74,5.91,5.91,0,0,0,2.14-2.27,49.45,49.45,0,0,0-.23-6.85s-.56-4-1-5.66Z"
						/>
						<path
							fill={props.mainColor || "white"}
							stroke={props.strokeColor || "#384f64"}
							className="cls-2"
							d="M106,89.7a153.5,153.5,0,0,1-22.37-.61s11.51-8.25,23,.68Z"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternBicolor = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Bicolor cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_7" data-name="Layer 7">
					<path
						className="cls-1"
						stroke={props.strokeColor || "#384f64"}
						fill={props.mainColor || "white"}
						d="M22.3,87.76S23.07,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.55,63.15,3.35,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.91,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.9,42a6,6,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.53,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.41,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M9.51,44.5s.63,2,1.88,2.09,5.46,1.77,5.74,4.55,1,3-1.14,7.61a1.72,1.72,0,0,1-.65.74,6.06,6.06,0,0,1-5.1.84,14.15,14.15,0,0,0-4.85-.87.84.84,0,0,1-.27,0c-.73-.24-4-1.48-1.87-3.88.58-.65,1-1.15,1.25-1.48A1.37,1.37,0,0,0,4.76,53a6.07,6.07,0,0,0-.31-1.13c-.34-.84,1.31-3,1.31-3A24.47,24.47,0,0,1,7.7,46.73,4.81,4.81,0,0,0,9.51,44.5Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M10.2,40.37s2.15,1.5,2.43,3.32a1.54,1.54,0,0,0,1.95,1.15,4.4,4.4,0,0,1,3.7,1A9.06,9.06,0,0,1,22.34,51a17.57,17.57,0,0,1,.82,4.15,1.54,1.54,0,0,0,2.27.51,39.24,39.24,0,0,0,6-3.83,5.1,5.1,0,0,0,1.1-1.53l-9-4.21-3.24-1.44A5.29,5.29,0,0,1,17.9,42a6.58,6.58,0,0,0-1.34-2.2s-2.5-2-4.25-2.12c0,0-1.47-.06-1.7.5A7.85,7.85,0,0,0,10.2,40.37Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M39.15,51.25a6.71,6.71,0,0,0-3,4.18s-.83,4.79,3.39,4.85,4.27-2.62,4.27-2.62,6.2-1.59,5.94,6.2c0,0-1,3.83,2,5.74S56,74.2,54.86,78a2.45,2.45,0,0,0-.71,2.24s0,.7,1.12,1.46A7.67,7.67,0,0,1,56.74,88l4.94.31a6.44,6.44,0,0,1,6.13-5.67,3.93,3.93,0,0,1,4.09,2.49s-.25,2.14,2.75,3.72l2.81.09s-1.86-4.89,1-8.4,5.11-3.26,5.11-3.26a1.58,1.58,0,0,1,1.66.77c.64,1-.26,2.42-.26,2.42s-2.1,3.07.74,9.26l3.58,3.08s10.88-4.42,13.88-11.19,16.21-7,16.21-7,2.53.09,3.69,1.64c0,0-6.81-18.93-7.58-19a12.66,12.66,0,0,1,.92-9.7s3.67-7.75,4.47-12.13l3.24-10.92a54.25,54.25,0,0,1,5.4-12.77l4.35-7.38s2-3.75-.13-4.1a15.28,15.28,0,0,0-6.61,1.86s-2.13.79-6.7,6.66a75.65,75.65,0,0,0-4.58,9.07s-.7,1.92-2,6.23l-2.79,8.87a61.66,61.66,0,0,1-3.54,8.24A30.8,30.8,0,0,1,103.77,47a2.94,2.94,0,0,1-2.58,1.2s-13.31.5-15.49.6l-19.8,1L47.26,50.88l-4.95.31Z"
					/>
					<path
						className="cls-1"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M5.15,62.14a17.66,17.66,0,0,1,7.67-.33c4,.8,2.8,3,2.8,3s-3-2-5-2a17.6,17.6,0,0,0-2.76-.13A9.29,9.29,0,0,1,5.15,62.14Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M15.79,94.88s.48,2.84-.95,4.27a4.57,4.57,0,0,1-3.55,1.15Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M93.62,99.07s6.6-.7,11.35-4.81c0,0,1.4,4.84,1.19,5.41,0,0,.4,2.25-2.69,5.5l-1.72,1.88s-3.17-1.74-5.72-1.39-3.68.59-3.68.59a8.42,8.42,0,0,0,1.46-2.84A8.07,8.07,0,0,0,93.62,99.07Z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternBicolorTabby = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Bicolor tabby cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_10" data-name="Layer 10">
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.mainColor || "white"}
						className="cls-1"
						d="M22.3,87.76S23.07,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.55,63.15,3.35,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.91,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.9,42a6,6,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.53,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.41,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M4.87,50s.87,6.8,6.66,7c0,0,5.27.76,8.76-.67s3.93-6,3.93-6,.57-.62,1.15.72a3.52,3.52,0,0,0,2.06,2.57,7.12,7.12,0,0,0,3.59,0,4.28,4.28,0,0,1,3.68,2.22c1.53,2.39,1.63,5.79,5.12,8.09a9.42,9.42,0,0,0,6.47,1.72s3.2-.76,2.87-5.07,4.21-1.34,4.5-.34,2.58,10.68,6.8,16.57,7.47,6.6,7.47,6.6,4.64,2.06,6.94-.86,1.62-4.26,1.62-4.26.39-5.93,6.56-.76c0,0,5.17,4.64,11.21,4.78s7-6.65,6.41-9.57c0,0-1-4.88,2.78-2.25s12.21,3.81,16.61-3L115.2,56.39a14.57,14.57,0,0,1,1.22-8.84,45.32,45.32,0,0,0,3.48-9l4-13.19s2.44-8.31,4.91-12.22l3.95-6.94,1.7-2.71S135.6,1,133.75.25a14.31,14.31,0,0,0-4.24.76s-3.1.61-6.45,4.6l-2.62,3.16-2.62,4.88L115,20,113.36,26s-1.68,5.39-2,6.13-2.16,5.64-2.16,5.64L106,44s-2,3.43-3,3.72,0,.19-2.8.53l-8.36.31-9.09.4-11.27.55-13.5.74-11.33.66-6.22.35s-5.65-.15-6.77-.37l-7.93-3.82L20,44.47a6.19,6.19,0,0,1-2.47-3.39s-1.09-1.87-2.31-2.31a5.09,5.09,0,0,0-3.56-1.07,1.41,1.41,0,0,0-1.33,1.51l0,2.59s.26,1.76-1.59,4.06a13.51,13.51,0,0,0-2.43,2.45Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M125,21.79a21.73,21.73,0,0,0-4.34-1.11,1.87,1.87,0,0,0-1.72.59,1,1,0,0,0-.18.77A2,2,0,0,0,120,23.6a34.44,34.44,0,0,0,3.57,1.17c.49.14.41-.3.61-.78l.82-2.2"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M17.36,48.68s-1.72,2.86-2.91,3.54a.52.52,0,0,0-.14.69.65.65,0,0,0,1,.29,9.55,9.55,0,0,0,3-3,.78.78,0,0,0-.18-1l-.73-.53"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M64.86,49.88s.77,10.69-1.07,15.23c0,0-.49,1.37,1.21,1.67s2.83-.86,3.46-2.16,4.13-7.09,3-13.63c-.09-.52-.51-1.29-1-1.26l-5.53.15"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M56.58,50.33s.82,6.78-.17,9.77c0,0-.26.89.77.74a2.84,2.84,0,0,0,2-1.94c.33-.83,2.52-5.06,1.66-8.62-.07-.29-.45-.17-.89-.15l-3.4.2"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M77.3,49.34S78,61,76,66c0,0,0,1.59,1.32,1.83,1.86.33,3.11-1,3.8-2.37a44.31,44.31,0,0,0,2.93-15.33c0-.57-.27-1.17-.84-1.17l-5.94.4"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M91.88,48.57s.24,10.3-1.12,14.92a1,1,0,0,0,0,.39,1.83,1.83,0,0,0,1.19,1.44c1.59.67,2.83-.86,3.46-2.16a35.78,35.78,0,0,0,2.74-13.89A1,1,0,0,0,97,48.39l-5.13.18"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M15.09,54.35a.54.54,0,0,0-.32.69.79.79,0,0,0,1,.57,8.28,8.28,0,0,0,4-2.36,2.12,2.12,0,0,0,.45-.72v-.29a.64.64,0,0,0-.6-.71s-.23-.3-1.31.74A14.79,14.79,0,0,1,15.09,54.35Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M12.26,50.53a.38.38,0,0,0-.06.5.46.46,0,0,0,.71.15,5.5,5.5,0,0,0,2-2.29,1.36,1.36,0,0,0,.14-.55l0-.18a.39.39,0,0,0-.48-.33s-.19-.14-.65.73A10,10,0,0,1,12.26,50.53Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M117.91,13.74a11,11,0,0,0,4,1.59c1.6.06,1.79-.79,1.79-.79a1.57,1.57,0,0,0-.77-2,31.58,31.58,0,0,0-3.17-1.61c-.5-.21-.57.27-.82.75l-1,2.08"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M112.17,29.74a12.4,12.4,0,0,0,4.41.84c1.58-.22,1.62-1.09,1.62-1.09a1.56,1.56,0,0,0-1.11-1.85,25.81,25.81,0,0,0-3.12-.93c-.54-.14-.74-.38-.89.16l-.9,2.95"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M117.42,45.48s-6.84-2.91-9.66-3.46a1,1,0,0,0-1.1.51l-1.12,2.15c-.32.58-.41.72.22.9,1.18.33,3.46,1.12,4.66,1.61l4,1.65c.51.21,1.12.56,1.35,0l1.45-3.41"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						className="cls-3"
						d="M120.49,36.25a91.43,91.43,0,0,0-9.6-2.08c-.33,0-.64,1-.64,1l-.7,2c-.25.6.37.67,1,.78,1.13.18,2.78.47,3.93.78s2.84.86,3.87,1.07c1.35.29,1.18-.09,1.32-.61l.84-2.84"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternVan = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Van cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_6" data-name="Layer 6">
					<path
						className="cls-1"
						fill={props.mainColor || "white"}
						stroke={props.strokeColor || "#384f64"}
						d="M22.3,87.77S23.07,73.7,18,67a12,12,0,0,0-8.9-4.31S5.55,63.17,3.35,61a10.44,10.44,0,0,0-2.21-2.14s-2-.74,0-3.51a22.34,22.34,0,0,0,2.78-4s2.68-3.82,4.4-5.07a7,7,0,0,0,1.92-4.4S10,38.08,10.91,38c0,0,1.72-1.44,5.65,1.82A8.18,8.18,0,0,1,17.9,42a6,6,0,0,0,2.39,2.68s11.3,5,13.31,6.22a59.47,59.47,0,0,0,8.71.29s34.57-2.2,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.35,33.35,0,0,0,1.53-3.92s2-5.91,2.91-9.93c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.81,0,0-.76,2.29-2.58,8.42,0,0-3.83,13.89-6.13,17.81,0,0-3.06,5.94-.57,10.44,0,0,4.88,10,5.64,13.88,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.77,11.77,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.87-4-3a17.93,17.93,0,0,0-.28-9s-1-4.12-4.31-5.75c0,0-9.29-3.06-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,8s-1.24,1.22-6.22,1.81a7.69,7.69,0,0,1-4-.76s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.54,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.87-3.93-3.06a13,13,0,0,0,3.26-6.61A30.75,30.75,0,0,0,42.41,96s-1.53-3.54-3.35-4.31c0,0-2.59-1-6.22,2.49,0,0-7.76,5.93-11.11,7.66a42.54,42.54,0,0,0-5.84,3.44s-3.16,3-4.79,4.22a16.26,16.26,0,0,1-5.84,3.73s-2.58.86-3.06-1.53c0,0-.48-2.2,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.13Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						className="cls-2"
						d="M103.06,47.65s5.27,5.37,11.4,5.08c0,0,.24-2,3.15-7.71l3.75-11.15,3.86-12.82a51.89,51.89,0,0,1,4.93-10.42l4.27-7.11s1.2-2.46-.67-3.26a10.24,10.24,0,0,0-5.27,1.18s-2.95.45-8,7.34c0,0-4.22,6.75-5.49,11.42a90.4,90.4,0,0,1-3.47,11.7,60,60,0,0,1-4.09,9.6S104.88,46.76,103.06,47.65Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						className="cls-2"
						d="M19.39,44.05S18,46.17,13.45,46.89a2.78,2.78,0,0,0-2.16,2c-.57,1.77-2-1-2-1a1.68,1.68,0,0,0-1.39-1.28s2.24-1.92,2.28-4.22c0,0-.14-3.51.52-4.25,0,0,1.22-1.57,4.74.86,0,0,2,1.35,2.4,2.8C17.83,41.76,18.67,44,19.39,44.05Z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternPointed = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Pointed colored cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_11" data-name="Layer 11">
					<path
						className="cls-1"
						stroke={props.strokeColor || "#384f64"}
						fill={props.mainColor || "#cbd7e2"}
						d="M22.31,87.76S23.08,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.56,63.15,3.36,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.92,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.91,42a6.09,6.09,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.63,3.06c0,0-4.79.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.42,91S86,88.53,80.24,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.42,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M20.09,44.77a4,4,0,0,1-4.43,4.44c-4.82,0-5.22-1.22-7.21-3.12a6.46,6.46,0,0,0,1.8-4.29s-.22-3.39.45-3.71c0,0,1.6-1.35,4.24.53l1.63,1.17a8.61,8.61,0,0,1,1.49,2.52A6,6,0,0,0,20.09,44.77Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M5,49.8a4.94,4.94,0,0,1,1.79,3.62,5.2,5.2,0,0,0,.89,3.29A4.41,4.41,0,0,1,10,60c.06,2.11-.42,2.53-.42,2.53l-.43.16a5.33,5.33,0,0,1-2.23-.07s-2.58-.3-3.66-1.84a8.08,8.08,0,0,0-1.87-1.83c-1.16-.8-.19-.12-.19-.12s-1.66-.43-.47-2.77a19.85,19.85,0,0,1,1.83-2.48S3.56,52,3.71,51.72,5,49.8,5,49.8Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M19.89,90.43s-.19,5.06,12.71,3.81l-4.85,3.69-3.91,2.67-3.65,2a22.59,22.59,0,0,0-4.13,2.53l-4.77,4.2a19.45,19.45,0,0,1-3.74,2.81S5,113.91,3.43,113.25c0,0-1.47-.29-1.19-2.25a8.4,8.4,0,0,1,1.62-3.15,32.52,32.52,0,0,1,3.73-3.78s3.54-3.55,3.71-3.77,3.37-4.12,3.37-4.12l2.71-3Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M41.79,94.75A12.85,12.85,0,0,1,46,93.22a8.7,8.7,0,0,1,6.79,1.53l-1,11.48-.6,4.73s-.58,4-1.3,4.92-.5,1-1.29,1.43a14.94,14.94,0,0,1-4.48,1.36,4.48,4.48,0,0,1-3.59-.77c-.47-.52-.51-1.52.38-2.68s1.3-1.82,1.3-1.82a12.84,12.84,0,0,0,1.38-3.25,20.29,20.29,0,0,0,.44-4.66c0-1.51-.4-4.89-.4-4.89A18.23,18.23,0,0,0,41.79,94.75Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M92.38,96.76s4.85,1.24,12.24-3.64a38.65,38.65,0,0,1,1.51,6c0,1.4.45,1.33-.95,3.75a44.62,44.62,0,0,1-3.72,4.48c-1.59,1.54-3.45,3.16-3.45,3.16l-4.12,3A8.94,8.94,0,0,1,90.45,115c-2.06.4-4.11.92-5.58.35a2.25,2.25,0,0,1-1.72-1.21s-1-1.79,1.49-2.91l4.27-2.43,2.86-2a6.84,6.84,0,0,0,2.28-4.72,5.56,5.56,0,0,0-.76-3.74Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M123.43,96.49s3.76-7,10.18-7.93A12.91,12.91,0,0,1,136.69,95s1.84,5.14,1.87,7c0,0,1.28,6.94.75,10.33a7.29,7.29,0,0,1-3.63,3.06s-3.23,1-4.08-1.79a37.51,37.51,0,0,0,.46-6.06s-.16-4.46-1.81-6.76c0,0-1.62-2.57-3.35-3.15Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M103.42,47.65s5.27,5.37,11.4,5.08c0,0,.25-2,3.15-7.71l3.75-11.15,3.87-12.82a51.42,51.42,0,0,1,4.92-10.42l4.27-7.11s1.2-2.46-.67-3.26a10.24,10.24,0,0,0-5.27,1.18s-3,.45-8,7.34c0,0-4.22,6.75-5.49,11.42a91.28,91.28,0,0,1-3.46,11.7,60.81,60.81,0,0,1-4.1,9.6S105.24,46.76,103.42,47.65Z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternTabby = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Tabby cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_4" data-name="Layer 4">
					<path
						className="cls-1"
						stroke={props.strokeColor || "#384f64"}
						fill={props.mainColor || "#cbd7e2"}
						d="M22.3,87.76S23.07,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.55,63.15,3.35,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.91,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.9,42a6,6,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.53,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.41,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
					/>
				</g>
				<g id="Layer_9" data-name="Layer 9">
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M6.33,48.18s-.6,1.66-.66,2.08a2.39,2.39,0,0,0,0,1.34c.33,1.08,1.18.22,1.21-.32,0,0,.48-3.72,1.31-4.81s-1.86,1.71-1.86,1.71"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M24.15,46.4s-1.57,4.24-3,5.46a.68.68,0,0,0,0,1,.91.91,0,0,0,1.41.13,13.06,13.06,0,0,0,3.57-5.65l-2-.89"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M49,50.93s.69,10.15-1.14,14.69c0,0-.49,1.37,1.2,1.67s2.84-.86,3.47-2.17S57,57.48,55.32,50.57L49,50.93"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M61.29,50.29s.33,13.77-2.36,19.48c0,0-.73,1.71,1.41,2S64,70.44,64.92,68.8s6-9.75,4.35-19.08l-8,.57"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M75.69,49.3s.72,11.84-1.29,16.83c0,0,0,1.59,1.33,1.83,1.86.33,3.1-.95,3.79-2.37a44.36,44.36,0,0,0,2.93-16.37l-6.76.08"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M85.92,48.92S86.16,59.46,84.75,64A1.79,1.79,0,0,0,86,65.67c1.59.67,2.84-.86,3.47-2.17a35.24,35.24,0,0,0,2.69-14.92l-6.19.34"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						d="M109.7,91s4.64-5.27,6.1-7.41a.81.81,0,0,1,1-.11c.79.42.65,1.53.39,2.29a15.62,15.62,0,0,1-4,6.78L109.7,91"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M115.85,93.65s4.24-4.66,5.57-6.56a.76.76,0,0,1,.93-.1c.72.37.59,1.35.35,2a12.71,12.71,0,0,1-3.41,6l-3.44-1.36"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M21.45,88.7s3.79,3,5.55,4.13a.49.49,0,0,1,0,.72c-.42.53-1.38.39-2,.17s-3.7-.78-5.62-2.76l2.06-2.26"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M17.6,92.92s3.61,2.5,5.32,3.41a.36.36,0,0,1,0,.59c-.42.44-1.51.4-2.3.3a9.91,9.91,0,0,1-5.17-2l2.12-2.31"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M22.28,54.7a.69.69,0,0,0-.28,1,1.05,1.05,0,0,0,1.47.57,11.12,11.12,0,0,0,4.9-3.88,2.72,2.72,0,0,0,.46-1.05l0-.38a.86.86,0,0,0-.94-.82s-.37-.35-1.59,1.23A20.15,20.15,0,0,1,22.28,54.7Z"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M119.38,11.14a11,11,0,0,0,4,1.59c1.6.06,1.79-.79,1.79-.79a1.57,1.57,0,0,0-.77-2,25.77,25.77,0,0,0-3.51-1.66l-1.5,2.88"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						d="M114,23.88s2.88,1.09,4.46.87,1.62-1.1,1.62-1.1A1.57,1.57,0,0,0,119,21.8a35.43,35.43,0,0,0-4.1-1.16L114,23.88"
					/>

					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M118.13,43.68s-8-3.4-10.09-3.42l-2,3.57a56,56,0,0,1,5.41,1.69l5,2,1.71-3.87"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M121,35.29s-7.83-2.36-9.81-2.16l-1.49,3.55a51.17,51.17,0,0,1,5.24,1l4.85,1.38L121,35.29"
					/>
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#89a4bd"}
						className="cls-2"
						d="M126.71,17.33a21.73,21.73,0,0,0-4.34-1.11c-1.65-.11-1.9,1-1.9,1a1.93,1.93,0,0,0,1.25,2,26,26,0,0,0,3.69,1.2l1.3-3"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternCalico = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Calico cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_5" data-name="Layer 5">
					<path
						stroke={props.strokeColor || "#384f64"}
						fill={props.mainColor || "white"}
						className="cls-1"
						d="M22.3,87.76S23.07,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.55,63.15,3.35,61a10.5,10.5,0,0,0-2.21-2.13s-2-.74,0-3.52a22.11,22.11,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.92-4.41S10,38.07,10.91,38c0,0,1.72-1.43,5.65,1.82A8.18,8.18,0,0,1,17.9,42a5.49,5.49,0,0,0,2.39,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.57-2.21,59.17-3c0,0,1.34.38,3.55-2.68,0,0,4-6.32,5.07-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.91-9.92c0,0,.76-3.7,5.9-12.77,0,0,4.21-5.84,7.76-7.18,0,0,1.53-1,5.55-1.34,0,0,1.66.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.76,2.3-2.58,8.43,0,0-3.83,13.88-6.13,17.81,0,0-3.06,5.93-.57,10.43,0,0,4.88,10,5.64,13.89,0,0,2.49,8,4.6,9.67a50.33,50.33,0,0,0,5.84,5.55,11.73,11.73,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.57,1.72-3.64,3.06c0,0-4.78.86-4-3a17.92,17.92,0,0,0-.28-9s-1-4.11-4.31-5.74c0,0-9.29-3.07-13.21-4.88,0,0-5.46-2.4-6.42-2.78,0,0-3-1.63-3.16,2,0,0,1.92,5.46,1.92,8s-3.26,5.74-3.26,5.74a42.73,42.73,0,0,1-9.29,7.95s-1.24,1.22-6.22,1.8a7.64,7.64,0,0,1-4-.75s-1.44-2.58,1.24-3.54c0,0,5.65-3,7.47-4.69a7.51,7.51,0,0,0,1.72-7A23.32,23.32,0,0,0,87.41,91S86,88.53,80.23,89c0,0-24-.67-27.1-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.38,1.72-5.07,2.39,0,0-6,.86-3.93-3.06a13.05,13.05,0,0,0,3.26-6.61A30.79,30.79,0,0,0,42.41,96s-1.53-3.54-3.35-4.3c0,0-2.59-1.06-6.22,2.49,0,0-7.76,5.93-11.11,7.66a41.45,41.45,0,0,0-5.84,3.44s-3.16,3-4.79,4.21a16.2,16.2,0,0,1-5.84,3.74s-2.58.86-3.06-1.53c0,0-.48-2.21,3.73-6,0,0,4.88-4.69,5.36-5.36,0,0,4.12-5.17,5.17-6.12Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M12.51,54.66c3.12.52,5.42-3,5.42-3s2.43-2.86,4.79.58,8.77-.32,6.46-3.54l-8.89-4s-1.34-.29-3-3.94a15.23,15.23,0,0,0-2-1.93s-2.27-1.46-3.3-1.15c0,0-1.7-.15-1.7,2,0,0,.29,3.47-.81,5,0,0-.21.89-2.33,2.66C7.09,47.33,5.09,53.45,12.51,54.66Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M38.73,51.24s-5.42,8-3.44,16.57S41,75.15,41,75.15s2.55-1.21,5,1.73a9.64,9.64,0,0,0,6.51,4.78c4.85,1.15,7-5.93,5.11-8.87,0,0-.9-2.23,1.46-1.27,0,0,6.39,2,8.3-1s2-4.34,2.34-7a.78.78,0,0,1,.54-1.09,12.18,12.18,0,0,0,2.1-8.68s.19-3.06,3.07-2.11l-.58-2.32L59,50.2l-17.23,1Z"
					/>
					<path
						className="cls-3"
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						d="M41,51.26s.06,7,3,11,5.42,5.11,5.42,5.11,5,3.25,8-.83a2.75,2.75,0,0,1,1.08-2.11s2.87-.32,2.55-2.3c0,0,.45-4.78-4.08-4.91,0,0-3.38-1-3.45-3.19,0,0-.25-1.79,2.3.32,0,0,3.38,1.66,3.32-1A3.06,3.06,0,0,0,57,50.31Z"
					/>
					<path
						className="cls-3"
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						d="M86.23,48.81s.19,7.83,1.72,10,5.36,2,6.13,0A22.43,22.43,0,0,1,97.21,54s2-2.93,5.36-.57,3.06,7,3.06,7,2.11,9.08-1.66,16.49-8.61,1.27-8.61,1.27-3.07-4.4-3.2-9c0,0-1.28-4.85-5.93-2.29a7.11,7.11,0,0,1-3.94-.31c-1.72-.64-3.65-2.12-5-5.37a9.24,9.24,0,0,1-1.21-7.54l-.57-2-.58-2.32Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M85.59,67.43s-2,8.94,3.45,14a22.25,22.25,0,0,0,12.32,5.49s6.63,1.28,10.4-.77,4.15,1.92,4.15,1.92a8.4,8.4,0,0,1,0,3.32c-.38,1.66-1,1.94-1,1.94l9.52,3.52s5.71-3.5,4.66-12.21l-3.88-4.08a36.27,36.27,0,0,1-3.48-7.94S119.92,67,119.06,65l-2.87-6.31s-2.15-3.66-1.09-7.12a15.57,15.57,0,0,1,1.83-5s.45.57-5,.7-7.73-.7-7.73-.7A3.68,3.68,0,0,1,101,48.23l-14.81.58s0,8.28,2.32,10.64a3.58,3.58,0,0,0,4.87.26s3.74-6.87,5-6.82c0,0,3.27-2.21,6.37,3.36,0,0,.57,2.89.8,4.14s1.29,6.79.19,10.82c0,0-.45,5.43-4.25,8.68,0,0-3.15,2.21-6.47-2.13,0,0-2.81-4.63-2.91-8.09,0,0-.91-3.48-2.69-3.45A4,4,0,0,0,85.59,67.43Z"
					/>
					<path
						className="cls-3"
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						d="M111.86,30.78s2.69,2.71,9.4,3.41a105.86,105.86,0,0,1-4.33,12.37s-4.43,1.66-12.71,0a41.86,41.86,0,0,0,4.79-8.3Z"
					/>
					<path
						className="cls-3"
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						d="M125.86,3s3.9,3,5.24,6l3.13-5.15s1.47-2.69-.48-3.55C133.75.25,128.72.29,125.86,3Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M111.86,30.78a15.91,15.91,0,0,0,9.4,3.41L125,21.7a53.36,53.36,0,0,1,4.06-9.12l2-3.63a18.42,18.42,0,0,0-5.24-6s-4.22,3.62-5.42,5.78c0,0-4,6.7-4.41,8.74a58.14,58.14,0,0,0-3.29,10.15Z"
					/>
					<path
						className="cls-3"
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						d="M117.63,14s3-2.71,4.09-3,2-.2,2.49.51a2.39,2.39,0,0,1-.58,2.51,22.74,22.74,0,0,1-4.91,5.21,22.86,22.86,0,0,0-5.13,5.89A53.71,53.71,0,0,1,117.63,14Z"
					/>
					<path
						className="cls-3"
						stroke={props.strokeColor || "#384f64"}
						fill={props.tertiaryColor || "#384f64"}
						d="M91.61,95.61a5.65,5.65,0,0,1,5.73-1.18,5.24,5.24,0,0,1,3.12,4.79s0,3.25-4.08,4.66a4,4,0,0,1-2.52-.68A7.06,7.06,0,0,0,93.58,99Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#cbd7e2"}
						d="M21.46,75.84a12.37,12.37,0,0,1,7.83,6c2.75,5-1.21,9.51-3.32,9.9a6.73,6.73,0,0,1-6-1.32l2.37-2.61S22.74,80.51,21.46,75.84Z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const CatPatternTortoiseshell = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 139.6 118.92"
			strokeWidth="0.5px"
			strokeLinecap="round"
			strokeLinejoin="round">
			<title>Tortoiseshell cat</title>
			<g id="Layer_2" data-name="Layer 2">
				<g id="Layer_12" data-name="Layer 12">
					<path
						className="cls-1"
						stroke={props.strokeColor || "#384f64"}
						fill={props.mainColor || "#cbd7e2"}
						d="M22.35,87.76S23.11,73.69,18,67a11.93,11.93,0,0,0-8.9-4.3S5.59,63.15,3.39,61a10.62,10.62,0,0,0-2.2-2.13s-2-.74,0-3.52a22.66,22.66,0,0,0,2.78-4s2.68-3.83,4.4-5.07a7,7,0,0,0,1.91-4.41S10,38.07,11,38c0,0,1.73-1.43,5.65,1.82A7.93,7.93,0,0,1,17.94,42a6.07,6.07,0,0,0,2.4,2.69s11.3,5,13.31,6.22a61,61,0,0,0,8.71.29s34.56-2.21,59.17-3c0,0,1.34.38,3.54-2.68,0,0,4-6.32,5.08-10.15a33.28,33.28,0,0,0,1.53-3.93s2-5.9,2.9-9.92c0,0,.77-3.7,5.91-12.77,0,0,4.21-5.84,7.75-7.18,0,0,1.53-1,5.56-1.34,0,0,1.65.29.67,3.26,0,0-7,10.72-9.29,17.8,0,0-.77,2.3-2.59,8.43,0,0-3.83,13.88-6.12,17.81,0,0-3.07,5.93-.58,10.43,0,0,4.88,10,5.65,13.89,0,0,2.49,8,4.6,9.67A49.42,49.42,0,0,0,132,87.09a11.78,11.78,0,0,1,4.69,7.76,46.87,46.87,0,0,1,2.68,17.52s-.58,1.72-3.64,3.06c0,0-4.79.86-4-3a17.86,17.86,0,0,0-.29-9s-1-4.11-4.31-5.74c0,0-9.28-3.07-13.21-4.88,0,0-5.46-2.4-6.41-2.78,0,0-3-1.63-3.16,2,0,0,1.91,5.46,1.91,8s-3.25,5.74-3.25,5.74a43,43,0,0,1-9.29,7.95s-1.25,1.22-6.23,1.8a7.65,7.65,0,0,1-4-.75s-1.43-2.58,1.25-3.54c0,0,5.65-3,7.47-4.69a7.54,7.54,0,0,0,1.72-7A23.42,23.42,0,0,0,87.45,91S86,88.53,80.27,89c0,0-24-.67-27.09-1.44,0,0-.67,13.69-1.15,16.28,0,0-.86,11.2-2.39,12.35,0,0-.39,1.72-5.08,2.39,0,0-6,.86-3.92-3.06a13,13,0,0,0,3.25-6.61A30.79,30.79,0,0,0,42.45,96s-1.53-3.54-3.35-4.3c0,0-2.58-1.06-6.22,2.49,0,0-7.75,5.93-11.11,7.66a42,42,0,0,0-5.84,3.44s-3.16,3-4.78,4.21a16.32,16.32,0,0,1-5.84,3.74s-2.59.86-3.07-1.53c0,0-.48-2.21,3.74-6,0,0,4.88-4.69,5.36-5.36,0,0,4.11-5.17,5.17-6.12Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M9.17,45.2s1.77,2.73,3.81,3.37,2,1.79,2,1.79,0,1.78-2.92,1.21a6.28,6.28,0,0,1-4-2.23s-1.47-.77-2.3.38c0,0-1.27.76-1.34,3.83a4,4,0,0,0,2.87,3.89s8.63,2,4.86,5.75a26.85,26.85,0,0,0-3.08-.51c-.5,0-3.83.25-5.5-1.51a12.11,12.11,0,0,0-2.45-2.35s-2-.88-.19-3.24l2.05-2.72,1.52-2.41a40.52,40.52,0,0,1,2.67-3.22l1.13-1Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M26.89,47.62S36,55.85,33.41,63.19s-4.73,9.89-4.73,9.89-5.68,7.08.77,10.34S42,75.31,42,75.31s1.34-4.08,3.39-2.8c0,0,.89,1.34-.77,3.83,0,0-.38,5.17,5.68,1.4A4.51,4.51,0,0,0,50,71.48c-3.06-3.19-2.17-8.29-2.17-8.29S48,58,49.75,56.87c0,0,.83-3.64-3.13-3s-7.72-.13-8.49-2.65l-4.48-.32Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M19.78,70s6-3.91,6.29-6.21,2.61-1.59,2.61-1.59,1.79.38,0,3.19-3.19,3.19-4.05,6.06a11.42,11.42,0,0,1-3,4.82A37.81,37.81,0,0,0,19.78,70Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M22.3,82.51s10.24,3.13,10.93,11.34l-6.31,4.69s-4.36-6.37-8.7-6.24l4.13-4.54Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						d="M3.93,107.82s4.74-.23,5.36,3.26a15.92,15.92,0,0,1-4,2.15c-1.78.51-3.24-.35-3-2.16A8.85,8.85,0,0,1,3.93,107.82Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M44,106.91s4.4.91,7.77-.63l-.47,3.84s-4.72,1.36-7.72,0C43.61,110.12,44.05,109.71,44,106.91Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M52.43,100s-9-4.15-7.47-10.79a8.37,8.37,0,0,1,7.79-6.72s4.53-1.39,4.66-4.9,7.15-4.85,9.7-1.79A8.88,8.88,0,0,1,69,82.51s.07,4.74,4.86,3.4A5.7,5.7,0,0,1,80.65,89l-19.14-.7s-5-.33-8.33-.71Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M59.39,52.78s-1,10.47,6.51,16.79S77.51,76,77.51,76s4.54,1.34,6,4.21,5,2.28,5,2.28,2.62-.49,2.43-3.94a20.45,20.45,0,0,0-2.36-7.34s-3.07-4-7.34-4.6-5.94.64-9.13-2.61-5-9.26-5-9.26-.93-4-4.33-3.7S59.39,52.78,59.39,52.78Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M69.85,52.21s-.73,6.38,5.28,8.74A6.89,6.89,0,0,0,84,58.08S84,55,85.36,54.31s2.75-1.42,2.62-3.26a4.51,4.51,0,0,0-.52-2.3l-9.31.43s.19,2.2-.76,2.33-1.41.1-1.73-.46a2.73,2.73,0,0,0-2.55-.95C72.41,50.42,70.61,50.1,69.85,52.21Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M83.62,89.09s18,2,21.61.84a2.68,2.68,0,0,0-.92,2.14s2.53,6.92,1.91,8c0,0,.42,1.93-4.09,6.68,0,0-5.43,6-8.73,7.21a13,13,0,0,1-6,1.6s-2.88.21-4-.75c0,0-1.43-2.17.67-3.27l6.83-4a7.08,7.08,0,0,0,3.17-6s.52-1.43-1.37-4.2c0,0-3-4.73-5.28-6.26A5.63,5.63,0,0,0,83.62,89.09Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M98.71,48.31S94.37,53,98.71,58a9.94,9.94,0,0,0,9.76,3.54s5.94-.48,4.28,5.52c0,0-.45,4-5.56,5s-3.63,5.49-3.63,5.49,1.66,4.21,7.78,3.19,9,1,9,1,1.73,3.19,3.58,3.06,3.1-.48,3.94-1.45L125.59,81A57.42,57.42,0,0,1,120,67.26s-3-7.65-4.14-9.28c0,0-2.6-3.79.58-10.43a52.63,52.63,0,0,0,4.13-11l2.59-8.76L124.94,22s-5.76.27-9.59-2.85c0,0-2.25,7.84-2.75,9.42l-2.45,6.78-2.34,5.41-3,5.11-2.13,2a4.4,4.4,0,0,1-1.13.29Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M125.19,3.57s-3,6.32,3.38,10L132.91,6l1.56-2.48s1.22-2.24-.67-3.26L129.67,1A22.05,22.05,0,0,0,125.19,3.57Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M132.09,107.42s4.1-2.07,7.19-.2l.07,5.15s-.53,1.88-3.64,3.06c0,0-4.07.79-4.1-2.14a28.28,28.28,0,0,0,.46-3.33C132.12,108.7,132.09,107.42,132.09,107.42Z"
					/>
					<path
						className="cls-2"
						stroke={props.strokeColor || "#384f64"}
						fill={props.secondaryColor || "#384f64"}
						d="M112.64,92.29s6-3.7,10.83-.7S127.63,98,127.63,98l-7.82-2.83Z"
					/>
				</g>
			</g>
		</svg>
	);
};